import { styled } from '@mui/material';

const GridContainer = styled('div')`
  height: inherit;
`;

export default GridContainer;
